// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__3LZH_","footer":"ModalFilter_footer__3Bpx4"};